import { Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export function SplashScreen() {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    let animationFrameId: number;
    let lastTimestamp: number;
    const rotationSpeed = 180;

    const animate = (timestamp: number) => {
      if (!lastTimestamp) lastTimestamp = timestamp;
      const deltaTime = (timestamp - lastTimestamp) / 1000;
      lastTimestamp = timestamp;

      setRotation((prev) => {
        const newRotation = prev + rotationSpeed * deltaTime;
        return newRotation >= 360 ? newRotation - 360 : newRotation;
      });

      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "background.paper",
        zIndex: 9999,
      }}
    >
      <div style={{ position: "relative", width: 100, height: 100 }}>
        {/* Static SVG background */}
        <img
          src="/images/bui16white.svg"
          alt="Logo"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />

        {/* Animated progress ring */}
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 100 100"
          style={{
            position: "absolute",
            transform: `rotate(${rotation}deg)`,
          }}
        >
          <circle
            cx="50"
            cy="50"
            r="45"
            fill="none"
            stroke="#1976d2" // MUI primary color
            strokeWidth="8"
            strokeDasharray="70, 200"
            strokeLinecap="round"
          />
        </svg>
      </div>

      <Typography variant="h6" sx={{ mt: 3 }}>
        Loading your wallet...
      </Typography>
    </motion.div>
  );
}
